import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useLanguage } from '../contexts/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// One-time first-login language chooser for school admins.
export default function LanguagePromptModal({ user, token }) {
  const { setLanguage } = useLanguage();
  const [dismissed, setDismissed] = useState(false);
  const [saving, setSaving] = useState(false);

  const show = user?.role === 'school_admin' && !user?.lang_prompt_seen && !dismissed;
  if (!show) return null;

  const choose = async (lang) => {
    setSaving(true);
    setLanguage(lang);
    try {
      await fetch(`${API_URL}/api/auth/language-preference`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ lang }),
      });
      try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        u.lang_prompt_seen = true; u.lang_pref = lang;
        localStorage.setItem('user', JSON.stringify(u));
      } catch (e) { /* noop */ }
      try { if (user?.id) localStorage.setItem(`langPromptDone:${user.id}`, '1'); } catch (e) { /* noop */ }
    } catch (e) { /* best-effort */ }
    finally {
      setDismissed(true); setSaving(false);
      // Let the onboarding tours know they can start now.
      try { window.dispatchEvent(new Event('lang-prompt:done')); } catch (e) { /* noop */ }
    }
  };

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 p-4" style={{ zIndex: 99999 }} data-testid="lang-prompt-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden">
        <div className="bg-gradient-to-r from-orange-500 to-amber-500 p-5 text-white text-center">
          <p className="text-3xl">🙏</p>
          <h2 className="text-lg font-bold mt-1">अपनी भाषा चुनें</h2>
          <p className="text-sm text-white/90">Choose your language</p>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-xs text-slate-500 text-center">आप इसे बाद में ऊपर EN/हिं toggle से कभी भी बदल सकते हैं।</p>
          <button onClick={() => choose('hi')} disabled={saving}
            className="w-full py-3 rounded-xl bg-orange-500 text-white font-bold hover:bg-orange-600 disabled:opacity-50" data-testid="lang-choose-hi">
            हिंदी में चलाएँ
          </button>
          <button onClick={() => choose('en')} disabled={saving}
            className="w-full py-3 rounded-xl border-2 border-slate-200 text-slate-700 font-bold hover:border-orange-300 disabled:opacity-50" data-testid="lang-choose-en">
            Continue in English
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
